<template>

  <div class="categoryGrid">
    <button 
      v-for="category in categories" :key="category.id"
      class="category" :class="{'active': selectedOptions.includes(category.id)}"
      @click="toggle(category.id)"
    >
      <img class="categoryIcon" :src="`/img/categoryIcons/${category.id}.png`">
      <span class="categoryLabel">{{ category.label }}</span>
    </button>
  </div>
  
</template>

<script lang="ts" setup>
import { ref, onMounted } from "vue";

const props = defineProps<{
  categories: {
    id: string,
    label: string
  }[],
  modelValue: string[],
}>();

const selectedOptions = ref<string[]>([]);

onMounted(() => {
  console.log(props.modelValue);
  selectedOptions.value = [...props.modelValue];
});

const emit = defineEmits(['update:modelValue'])

const toggle = (categoryId: string) => {
  console.log(props.modelValue);

  const idx = selectedOptions.value.indexOf(categoryId);
  if (idx == -1) {
    selectedOptions.value.push(categoryId);
  } else {
    selectedOptions.value.splice(idx, 1);
  }

  emit('update:modelValue', [...selectedOptions.value]);
};

</script>

<style lang="scss" scoped>
@import "../../../assets/variables.scss";

.categoryGrid {
  display: block;
}

.category {
  display: inline-flex;
  align-items: center;
  width: 48%;
  margin: 1%;
  background-color: white;
  border: 1px solid #7f7f7f;
  border-radius: 5px;

  cursor: pointer;
}

.categoryLabel {
  color: #7f7f7f;
  font-size: 125%;
  font-weight: bold;
}

@media screen and (max-width: $tabletWidth) {
  .category {
    width: 98%;
  }
}

.category.active {
  background-color: $primary;
}

.category.active > .categoryLabel {
  color: white;
}


.categoryIcon {
  width: 2.5rem;
  height: 2.5rem;
  margin: 0.2rem 0.7rem 0.2rem 0.4rem;
}
</style>
 